/** @module csi/def/SearchType */
define([
	"dojo/_base/declare",
	"csi/service/def/relationshipService",
	"csi/util"
], function(declare, {parseSort}, util) {

	return declare(null, {
		// summary: Global Search by Type class

		// Boolean: indicates if this class serves as a context for others (i.e. Season)
		bContext: false,

		// Boolean: if this class serves as a context for others (i.e. Season), then if true it will be sorted by creation date (in reverse) rather than by name
		bContextSortByLatest: false,

		// Card: card holding attributes to display for node
		card: null,

		// Object[]: additional filters applied to global search of node 
		filters: null,

		/** @property {string} pathToContext - path to reach context which will narrow scope of search */
		pathToContext: null,

		/** @property {IDataStoreSort[]} sorts - sort conditions when searching by type other than sorting by name */
		sorts: null,

		// String: type of node to search
		typeNode: null,

		constructor: function(def, typeNode) {
			this.typeNode = typeNode;
			this.filters = util.getElements(def, "Filter/child::*");
			this.bContext = (util.getProperty(def, "Context") == "1");
			this.bContextSortByLatest = (util.getProperty(def, "ContextSortByLatest") == "1");
			this.pathToContext = (util.getProperty(def, "PathToContext"));
			this.sorts = util.getDefs(def, "Sort", parseSort, true);
		}
	});
});